import { request } from "./request"

export const sharingApi = {
  updateSharingSettings: async (userID: number, nodeId: string, data:any): Promise<any> => {
    return request('PATCH', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/share`, data)
  },

  getSharingSettingsEnabled: async (userID: number, nodeId: string): Promise<any> => {
    return request('GET', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/share_permissions`)
  },

  getCollaborators: async (userID: number, nodeId: string): Promise<any> => {
    return request('GET', `/api/3/users/${userID}/fs/root/nodes/${nodeId}/share/collaborators/`)
  },

  getCollaboratorsList: async (userID: number): Promise<any> => {
    return request('GET', `/api/3/users/${userID}/collaborators`)
  }, 
  addCollaborator: async (userID: number, nodeId: string, data: any): Promise<any> => {
    return request('POST', `/api/2/users/${userID}/fs/root/nodes/${nodeId}/share/collaborators/`, data)
  },
}
